import React, { ReactNode } from 'react';
import { T } from '@transifex/react';

import {
  AlertCircle,
  CalendarCheck01,
  CheckCircle,
  Minus,
} from 'src/ui-new/icons';
import { TagProps } from 'src/antd';
import { success } from 'src/theme/colors';

export type TCollectionStatus =
  | 'PENDING'
  | 'SCHEDULED'
  | 'COMPLETE'
  | 'COMPLETE_WITH_TICKET'
  | 'COMPLETE_NOT_EMPTIED'
  | 'MISSED';

export const collectionStatusLabelMap: Record<TCollectionStatus, ReactNode> = {
  PENDING: <T _str="Pending" />,
  SCHEDULED: <T _str="Scheduled" />,
  COMPLETE: <T _str="Emptied" />,
  COMPLETE_WITH_TICKET: <T _str="Emptied" />,
  COMPLETE_NOT_EMPTIED: <T _str="Not Emptied" />,
  MISSED: <T _str="Missed" />,
};

export const collectionStatusIconMap: Record<TCollectionStatus, ReactNode> = {
  PENDING: <Minus size={21} style={{ color: '#8C8C8C' }} />,
  SCHEDULED: <CalendarCheck01 size={21} style={{ color: '#8C8C8C' }} />,
  COMPLETE: <CheckCircle size={21} style={{ color: success }} />,
  COMPLETE_WITH_TICKET: <CheckCircle size={21} style={{ color: '#FFC53D' }} />,
  COMPLETE_NOT_EMPTIED: <AlertCircle size={21} style={{ color: '#FF4D4F' }} />,
  MISSED: undefined,
};

export const collectionStatusApiConstMap: Record<number, TCollectionStatus> = {
  1: 'PENDING',
  2: 'SCHEDULED',
  3: 'COMPLETE',
  4: 'COMPLETE_NOT_EMPTIED',
  5: 'MISSED',
  6: 'COMPLETE_WITH_TICKET',
};

export const collectionStatusColorMap: Record<
  TCollectionStatus,
  TagProps['color']
> = {
  PENDING: 'default',
  SCHEDULED: '#595959',
  COMPLETE: 'green',
  COMPLETE_WITH_TICKET: 'yellow',
  COMPLETE_NOT_EMPTIED: 'red',
  MISSED: 'red',
};
